import { wp } from '@/lib/api'
import {
  mapSiteSettings,
  type RawSiteSettings,
  type SiteSettings,
} from '@/models/siteSettings'
import { get } from '@/services/http'

export const SiteSettingsService = {
  async get(): Promise<SiteSettings> {
    const req = get<RawSiteSettings>(
      'site-settings',
      undefined,
      {
        client: wp,
        dedupe: true,
        retry: { retries: 2 },
      },
    )

    return mapSiteSettings(await req.promise)
  },
}
